// @ts-ignore
export const jQuery = $;
